"use client";
import { jsxs as e, jsx as l } from "react/jsx-runtime";
const r = ({
  title: i,
  titleId: h,
  desc: d,
  descId: a,
  ...v
}) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-bv",
    viewBox: "0 0 640 480",
    "aria-labelledby": h,
    "aria-describedby": a,
    ...v,
    children: [
      d ? /* @__PURE__ */ l("desc", { id: a, children: d }) : null,
      i ? /* @__PURE__ */ l("title", { id: h, children: i }) : null,
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "bv-a", children: /* @__PURE__ */ l("path", { fillOpacity: 0.7, d: "M0 0h640v480H0z" }) }) }),
      /* @__PURE__ */ e("g", { fillRule: "evenodd", strokeWidth: "1pt", clipPath: "url(#bv-a)", children: [
        /* @__PURE__ */ l("path", { fill: "#fff", d: "M-28 0h699.7v512H-28z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#d72828",
            d: "M-53-77.8h218.7v276.2H-53zM289.4-.6h381v199h-381zM-27.6 320h190.4v190.3H-27.6zm319.6 2.1h378.3v188.2H292z"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "#003897", d: "M196.7-25.4H261v535.7h-64.5z" }),
        /* @__PURE__ */ l("path", { fill: "#003897", d: "M-27.6 224.8h698v63.5h-698z" })
      ] })
    ]
  }
);
export {
  r as default
};
